import { render, staticRenderFns } from "./Fiasp.vue?vue&type=template&id=1fec78dc&scoped=true&"
import script from "./Fiasp.vue?vue&type=script&lang=js&"
export * from "./Fiasp.vue?vue&type=script&lang=js&"
import style0 from "./Fiasp.vue?vue&type=style&index=0&id=1fec78dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fec78dc",
  null
  
)

export default component.exports